<template>
	<div id="bingli" style="height: 300px; margin:0 auto"  v-loading="loading" ref="share">
</div>
</template>

<script>
import echarts from 'echarts'
export default {
	name: 'bingli',
	props: {
		shareData: {
			default: {
			}
		},
	},

	data () {
		return {
			loading: false,
			datatime:[],
			bingli:[1,2,3,4],
			suifang:[],
			myChart: null, // 添加一个属性来存储ECharts实例
		}
	},
	watch: {
		shareData: {
			deep: true, // 深度监听，能够监听到对象内部值的变化
			// eslint-disable-next-line no-unused-vars
			handler(newVal, oldVal) {
				// 当 'shareData' 发生变化时，这个函数会被调用
				// 这里可以执行你需要的操作，例如更新组件状态或调用方法
				this.suifang = [this.shareData.death||0,this.shareData.remission||0,this.shareData.relapse||0,this.shareData.transplant||0]
				this.drawBar()
			}
		},
		bingli: {
			deep: true, // 深度监听，能够监听到对象内部值的变化
			// eslint-disable-next-line no-unused-vars
			handler(newVal, oldVal) {
				this.drawBar()
			}
		},
	},
	beforeDestroy() {
		if (this.myChart != null) {
			this.myChart.dispose(); // 销毁ECharts实例
		}
		window.removeEventListener('resize', this.handleResize); // 移除事件监听器
	},
	mounted () {
		let that = this
		that.loading = true
		this.$http.get('/case/dashboard/sharechart/').then(res => {
			if(res.data.code === 1){
				that.bingli = res.data.bingli
				that.datatime = res.data.datatime
				// that.bingli = this.bingli.map((value, index) => value - this.suifang[index])
				that.drawBar()
				window.addEventListener('resize', this.handleResize);
				that.loading = false
			}
		})
	},
	methods: {
		handleResize() {
			if (this.myChart) {
				this.myChart.resize(); // 调用resize方法调整图表大小
			}
		},
		drawBar () {
			let ziList = this.bingli.map((value, index) => {
				return value > this.suifang[index] ? value - this.suifang[index] : value;
			});
			this.myChart = echarts.init(this.$refs.share);
			let option =  {
				color: ['rgb(128, 176, 210)','#67c23a'],
				tooltip: {
					trigger: 'axis'
				},
				grid: {
					left: '3%',
					right: '3.5%',
					bottom: '2%',
					top:'14%',
					containLabel: true
				},
				legend: {
					// data: ['新增病例','随访待更新数']
				},
				xAxis:  {
					type: 'category',
					data: this.datatime
				},
				yAxis: {
					type: 'value',
				},
				series: [
				{
					name: '自主上报',
					type: 'bar',
					data: ziList,
					barGap: '40%',
					label:{
						normal:{
							show:true,
							position:'top',
							textStyle:{
								fontSize:14
							}
						}
					}
				},
				{
					name: '共享数据',
					type: 'bar',
					data:  this.suifang,
					label:{
						normal:{
							show:true,
							position:'top',
							textStyle:{
								fontSize:14
							}
						}
					}
				}
				]
			};
			this.myChart.setOption(option)
		},
	}
};
</script>
